import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6c11a42e&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/components/animate.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/components/beer-dash.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports